export function PhoneFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20.557 5.595L18.061 3.1a1.612 1.612 0 00-2.288 0l-2.688 2.683a1.618 1.618 0 000 2.293l2.1 2.102a9.503 9.503 0 01-2.025 2.983 9.522 9.522 0 01-2.981 2.03l-2.1-2.102a1.613 1.613 0 00-2.288 0l-2.69 2.683a1.618 1.618 0 000 2.293l2.494 2.493a2.806 2.806 0 002.423.78c3.103-.51 6.183-2.162 8.67-4.647 2.484-2.489 4.134-5.569 4.65-8.674a2.794 2.794 0 00-.781-2.423z"
      ></path>
    </svg>
  );
}
